/**
 * CURRENT_ATO_RULESET_VERSION — the single source of truth for which set of
 * Australian tax rules BuildIntel is currently applying.
 *
 * Rules for changing this value:
 *  1. Never mutate an existing ruleset in-place. Ship a NEW version instead.
 *  2. The moment this constant changes, EVERY future TaxGuidanceLog row is
 *     stamped with the new value — historical rows keep the old stamp, so
 *     numbers reproduce forever.
 *  3. Update `effectiveFrom` and `lastReviewed` in `registry.ts` when
 *     bumping. The registry is what the frontend renders in "About / Tax
 *     rules" so tradies can see what's in force.
 *
 * Format: `YYYY.N` where N increments within a calendar year
 *   ("2026.1", "2026.2", …). Pre-release versions may append `-tagname`
 *   ("2026.2-preview"), which will not be marked active in production.
 */
export const CURRENT_ATO_RULESET_VERSION = "2026.2" as const;

export type CurrentAtoRulesetVersion = typeof CURRENT_ATO_RULESET_VERSION;
